export const SET_LANGUAGE = 'set_language'


// WEBPACK FOOTER //
// ./src/store/types/language.js